import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { BONUS_API } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

export class BonusService {
  static getBonuses = async data => {
    try {
      const response = await HTTPHandler.post(BONUS_API + '/bonus/list', data)

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }
  static transferBonuses = async data => {
    try {
      const res = await HTTPHandler.post(
        BONUS_API + `/bonus/transferBonus`,
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static frozeBonus = async data => {
    try {
      const res = await HTTPHandler.post(BONUS_API + `/bonus/frozeBonus`, data)

      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static unfrozeBonus = async data => {
    try {
      const res = await HTTPHandler.post(
        BONUS_API + `/bonus/unfrozeBonus`,
        data
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }

  static spendBonus = async data => {
    try {
      const response = await HTTPHandler.post(
        BONUS_API + '/bonus/spendBonus',
        data
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }
  static sendOtpCode = async phoneNumber => {
    try {
      const response = await HTTPHandler.post(
        BONUS_API + `/otp/sendOtpCode/${phoneNumber}/true`
      )

      return formatResponse(response)
    } catch (error) {
      return createError(error)
    }
  }
}
